import React, { useEffect } from 'react';

import { Box, Typography } from '@mui/material';
import Logo from 'images/logo-white.svg';

import {
  RouterOutlet,
  useNavigate,
  useSelector,
  useTheme,
  useTranslation,
} from 'third-party';

import { userPaymentListUrl } from 'constants/url';

import { appSelectors } from 'selectors';

import { navGradient } from 'styles/theme';

export const AnonymsView = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const navigate = useNavigate();
  const userInfoPending = useSelector(appSelectors.userInfoPending);
  const user = useSelector(appSelectors.user);

  useEffect(() => {
    if (!userInfoPending && user) {
      navigate(userPaymentListUrl());
    }
  }, [navigate, user, userInfoPending]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        flexGrow: 1,
        height: '100%',
      }}
    >
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          justifyContent: 'space-between',
          minWidth: '25%',
          background: navGradient,
        }}
      >
        <Typography
          variant="h3"
          m="2rem"
          color={theme.custom.palette.whiteText}
        >
          <img src={Logo} height="40px" alt="Logo" />
        </Typography>
        <Typography
          variant="subtitle1"
          m="2rem"
          color={theme.custom.palette.whiteText}
        >
          {t('common.slogan')}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          maxWidth: '100%',
          flexGrow: 1,
          margin: { xs: '1rem', md: '0' },
        }}
      >
        <RouterOutlet />
      </Box>
    </Box>
  );
};
